import { render, staticRenderFns } from "./SettingsInput.vue?vue&type=template&id=a2cc8930&scoped=true&"
import script from "./SettingsInput.vue?vue&type=script&lang=js&"
export * from "./SettingsInput.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInput.vue?vue&type=style&index=0&id=a2cc8930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc8930",
  null
  
)

export default component.exports